export default "__VITE_ASSET__CD9hZdo5__"